import React from 'react';

import { routes } from '@aline/routes';
import { Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import {
  AlineTabs,
  ContentWrapper,
  ContractTypesTab,
  NewContractTypeButton,
  PageTitle,
  useSubheaderStyles,
} from 'src/components';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  grid: {
    flex: '1 1 auto',
    height: '100%',
    minWidth: 0,
  },
}));

const { toRelativePath: toRelativeIdentifiersPath } = createRelativeRouter(routes.IdentifierIndex, {
  nestedRoutes: true,
});

export function Identifiers(): JSX.Element | null {
  const { classes } = useStyles();

  return (
    <>
      <Helmet>
        <title>Identifiers</title>
      </Helmet>
      <Grid container className={classes.grid} wrap="nowrap">
        <ContentWrapper>
          <Grid container className={classes.grid} sx={{ flexDirection: 'column' }} wrap="nowrap">
            <IdentifiersSubheader />
            <Routes>
              <Route
                element={<ContractTypesTab />}
                path={toRelativeIdentifiersPath(routes.IdentifierContractTypes)}
              />
              <Route element={<Navigate replace to={routes.IdentifierContractTypes} />} path="/" />
            </Routes>
          </Grid>
        </ContentWrapper>
      </Grid>
    </>
  );
}

export function IdentifiersSubheader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { classes } = useSubheaderStyles();

  return (
    <div className={classes.root}>
      <PageTitle pageTitle="Identifiers" />
      <AlineTabs
        tabs={[{ label: 'Contract Types', value: routes.IdentifierContractTypes }]}
        value={location.pathname}
        onChange={value => navigate(value)}
      />

      <div className={classes.contentContainer}>
        <Routes>
          <Route element={<NewContractTypeButton />} path={routes.IdentifierContractTypes} />
        </Routes>
      </div>
    </div>
  );
}
